import React, { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import Header from "../Header/header";
import Sidebar from "../SideBar/SideBar";
import LoadingOverlay from "react-loading-overlay-ts";
import Box from "@mui/material/Box";
import SessionTimerService from "../../Services/SessionTimer";
import { useSelector } from "react-redux";
import { SessionSorageInstance } from "../../Services/SessionStorageService";
import AffiliateDashboard from "../Dashboard/AffiliateDashboard";

import "./AffiliateLayout.scss";
import AffiliateMonthlyBreakdown from "../AffiliateMonthlyBreakdown/AffiliateMonthlyBreakdown";

const AffiliateLayout = () => {
  const isActive = useSelector((state: any) => state.general.isActiveSpinner);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const sessionTimeoutInMinutes = 60;

  useEffect(() => {
    const sessionTimerService = new SessionTimerService(sessionTimeoutInMinutes);
    sessionTimerService.startSessionTimer(() => handleLogout());
    return () => sessionTimerService.stopSessionTimer();
  }, []);

  const handleLogout = () => {
    SessionSorageInstance.clearSessionStorage();
    navigate('/');
  };

  return (
    <div className="wrap">
      <LoadingOverlay active={isActive} spinner>
        <Box className="loader">
          <Box sx={{ display: 'flex' }}>
            <Header open={open} />
            <Sidebar open={open} setOpen={setOpen} />
            <Box className="wrap-layout" component="main">
              <Routes>
                <Route path="/" element={<AffiliateDashboard />} />
                <Route path="/affiliate-monthly-breakdown" element={<AffiliateMonthlyBreakdown/>} />
              </Routes>
            </Box>
          </Box>
        </Box>
      </LoadingOverlay>
    </div>
  );
};

export default AffiliateLayout;
